import React from "react";

// Logo oficial: se inserta SIEMPRE como imagen (nunca vectorizar / nunca ícono genérico).
// Fallback: solo texto "AUTOFINANZA" en Inter si la imagen no carga.
export default function Logo({ height = 44, withWordmark = true, className = "", testId = "af-logo" }) {
  const [failed, setFailed] = React.useState(false);
  if (failed) {
    return (
      <span
        data-testid={testId}
        className={`font-bold tracking-wide text-white ${className}`}
        style={{ fontSize: height * 0.5, fontFamily: "Inter, sans-serif" }}
      >
        AUTOFINANZA
      </span>
    );
  }
  return (
    <img
      data-testid={testId}
      src="/assets/logo.png"
      alt="Autofinanza"
      onError={() => setFailed(true)}
      style={{ height, width: "auto" }}
      className={`select-none ${className}`}
      draggable={false}
    />
  );
}
